import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from "prop-types"
import i18n from 'i18n/index.js'

function Guidebook(props) {
    let guide_image = "https://viewnia-static.s3.us-east-2.amazonaws.com/guidebook.jpg";
    return (
        <section className="advertise">
            <div className="guidebook">
                <div className="image">
                    <img src={guide_image} alt="Guide book" width="230" height="230" />
                </div>
                <div className="text">
                    <h1>{I18n.t('guidebook.download_our_guide_book')}</h1>
                    <p>{I18n.t('guidebook.find_out_everything')}</p>

                    <div className="actions">
                        {props.current_user &&
                            <button type='submit' className="primary"><a target="_blank" href="https://s3.amazonaws.com/view-patagonia/manual_uploads/GuideBook+Viewnia.com.zip">{I18n.t('home.download')}</a></button>
                            ||
                            <button type='submit' className="primary"><a href={`/${window.I18n.locale}/users/sign_up`}>{I18n.t("home.download")}</a></button>
                        }
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Guidebook

